import React from 'react';

import moment from 'moment';
import { Input, Tooltip, Button, DatePicker } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

const FormItem = Form.Item;
const { TextArea } = Input;

class FormRegistroEntradaSalida extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      existeVenta: false,
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Datos del Registro</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha de Recepcion
                <Tooltip title="Seleccione la Fecha de Recepcion">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaRecepcion', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'Por favor, seleccione la Fecha de Recepcion',
                },
              ],
            })(
              <DatePicker
                style={{ width: 400 }}
                placeholder="Fecha de Recepcion"
                format="DD/MM/YYYY"
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Organismo Origen
                <Tooltip title="Organismo Origen">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('organismoOrigen', {
              rules: [
                {
                  message: 'Por favor, ingresar el Organismo Origen!',
                  whitespace: true,
                },
              ],
            })(<Input style={{ width: 400 }} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Descripcion
                <Tooltip title="Si lo desea, escriba la descripcion del registro">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('descripcion', {})(
              <TextArea style={{ width: 400 }} rows={4} />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha de Devolucion
                <Tooltip title="Seleccione la fecha de Devolucion">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaDevolucion', {
              initialValue: undefined,
              rules: [
                {
                  type: 'object',
                  message: 'Por favor, seleccione la fecha de Devolucion',
                },
              ],
            })(
              <DatePicker
                style={{ width: 400 }}
                placeholder="Fecha de Devolucion"
                format="DD/MM/YYYY"
              />
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Guardar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      fechaRecepcion: Form.createFormField({
        value:
          props.datos && props.datos.fechaRecepcion
            ? moment(new Date(props.datos.fechaRecepcion), 'DD/MM/YYYY')
            : moment(),
      }),
      fechaDevolucion: Form.createFormField({
        value:
          props.datos && props.datos.fechaDevolucion
            ? moment(new Date(props.datos.fechaDevolucion), 'DD/MM/YYYY')
            : undefined,
      }),
      organismoOrigen: Form.createFormField({
        value: props.datos ? props.datos.organismoOrigen : '',
      }),
      descripcion: Form.createFormField({
        value: props.datos ? props.datos.descripcion : '',
      }),
    };
  },
})(FormRegistroEntradaSalida);
